import React from 'react';

import noop from 'lodash/noop';

import {useEvent} from '@edna/hooks';

import {TCloseWhen, TCloseWhenHandler} from './types';
import {closeWhenMap} from './utils';

export const useCloseHandler = (
  active: boolean,
  closeWhen: TCloseWhen | TCloseWhenHandler,
  onClose: TEmptyFunction,
) => {
  const headRef = React.useRef<HTMLDivElement>(null);
  const overlayRef = React.useRef<HTMLDivElement>(null);
  const dropdownRef = React.useRef<HTMLDivElement>(null);

  const handleClick = React.useCallback(
    (event: MouseEvent) => {
      const target = event.target as Node | null;
      const headNode = headRef.current;
      const overlayNode = overlayRef.current;
      const dropdownNode = dropdownRef.current;

      if (
        target === null ||
        headNode === null ||
        overlayNode === null ||
        dropdownNode === null ||
        (closeWhen !== 'clickOutsideDropdown' && headNode.contains(target)) ||
        // если клик на удаленный элемент, то не закрываем
        !document.documentElement.contains(target)
      ) {
        return;
      }

      const needClose = () => {
        if (typeof closeWhen === 'function') {
          return closeWhen(target, headNode, overlayNode, dropdownNode);
        }

        if (typeof closeWhen === 'string') {
          return closeWhenMap[closeWhen](target, headNode, overlayNode, dropdownNode);
        }

        return false;
      };

      if (needClose()) {
        onClose();
      }
    },
    [closeWhen, onClose],
  );

  useEvent('click', active ? handleClick : noop);

  return [headRef, overlayRef, dropdownRef];
};
